import { render, staticRenderFns } from "./FeatureSettings.vue?vue&type=template&id=260e041f&scoped=true&"
import script from "./FeatureSettings.vue?vue&type=script&lang=js&"
export * from "./FeatureSettings.vue?vue&type=script&lang=js&"
import style0 from "./FeatureSettings.vue?vue&type=style&index=0&id=260e041f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260e041f",
  null
  
)

export default component.exports